// Generated by purs version 0.15.0
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartData from "../Restaumatic.PromotionsEngine.Cart.CartData/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
var addValue = function (value) {
    return function (outputCartData) {
        return Restaumatic_PromotionsEngine_Cart_CartData.addToTotal(Data_Maybe.fromMaybe(Data_Numeric.zero(Data_Money_Rounded.additiveMoney))(value))(outputCartData);
    };
};
var addFreebies = function (v) {
    return function (outputCartData) {
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.Freeby) {
            return Restaumatic_PromotionsEngine_Cart_CartData.addFreeProducts(v.value0)(outputCartData);
        };
        return outputCartData;
    };
};
var applyPromotionalItem = function (outputCartData) {
    return function (promotionalItem) {
        var $4 = Restaumatic_PromotionsEngine_Cart_PromotionalItem.isEnabled(promotionalItem);
        if ($4) {
            return addFreebies(Restaumatic_PromotionsEngine_Promotions_Promotion.promotionPrize(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotion(promotionalItem)))(addValue(Restaumatic_PromotionsEngine_Cart_PromotionalItem.value(promotionalItem))(outputCartData));
        };
        return outputCartData;
    };
};
var evaluateCart = function (inputCartData) {
    return function (promotionalItems) {
        var defaultCart = Restaumatic_PromotionsEngine_Cart_CartData.mkDefaultOutputCartData(inputCartData)(promotionalItems);
        var outputCartData = Data_Foldable.foldl(Data_Foldable.foldableArray)(applyPromotionalItem)(defaultCart)(promotionalItems);
        return outputCartData;
    };
};
export {
    evaluateCart
};
//# sourceMappingURL=index.js.map
